<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 mx-auto">
        <div class="modal-content border-0 shadow">
          <div class="modal-header pb-0 border-0">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-block rounded-circle d-flex ms-auto"
                style="left: 0; top: 0"
                @click="close"
              >
                <v-icon
                  icon="times"
                  width="20"
                  height="20"
                />
              </button>
            </div>
          </div>
          <div class="modal-body pb-5">
            <section class="row">
              <div class="col-9 mx-auto">
                <div class="d-flex flex-column">
                  <img
                    :src="`${aws}/unicorn-feather.png`"
                    class="mx-auto mb-3 img-fluid"
                  >
                  <h5 class="text-center">
                    {{ title }}
                  </h5>
                  <p class="text-center mt-2">
                    {{ content }}
                  </p>
                  <button
                    type="button"
                    class="btn btn-primary mt-3"
                    @click="action"
                  >
                    <div class="d-flex flex-row justify-content-center">
                      {{ cta }}
                      <v-icon
                        icon="arrow-white-right"
                        class="ms-1"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

export default {
  name: 'AccountModal',
  mixins: [ui],
  data() {
    return {
      list: {
        sepa: { action: 'backAndClose' },
        creditCard: { action: 'backAndClose' },
        newMember: { action: 'backAndClose' },
        company: { action: 'backAndClose' },
        contact: { action: 'backAndClose' },
        password: { action: 'backAndClose' },
        createCompany: { action: 'backCompaniesAndClose' },
        default: { action: 'close' },
      },
    };
  },
  computed: {
    ...mapGetters({
      accountComponentType: 'ui/accountComponentType',
      accountComponentAction: 'ui/accountComponentAction',
    }),
    type() {
      return this.list[this.accountComponentType || 'default'];
    },
    title() {
      if (['deleteCreditCard', 'activateCreditCard', 'deleteMember'].includes(this.accountComponentType)) {
        return 'C\'est bon pour vous ?';
      }
      return 'C\'est bon pour nous !';
    },
    content() {
      if (this.accountComponentType === 'deleteCreditCard') {
        return 'Vous êtes sur le point de supprimer cette carte bancaire';
      }
      if (this.accountComponentType === 'activateCreditCard') {
        return 'Vous êtes en train de choisir cette carte comme carte principale. C’est désormais cette carte qui sera débitée.';
      }
      if (this.accountComponentType === 'activateSepa') {
        return 'Vous allez faire de ce RIB votre RIB principal. C’est désormais ce compte qui sera débité.';
      }
      if (this.accountComponentType === 'deleteSepa') {
        return 'Vous êtes sur le point de supprimer ce RIB';
      }
      if (this.accountComponentType === 'creditCard') {
        return 'Votre nouvelle carte bancaire a bien été ajoutée.';
      }
      if (this.accountComponentType === 'sepa') {
        return 'Votre nouveau RIB a bien été ajouté.';
      }
      if (this.accountComponentType === 'password') {
        return 'Votre mot de passe a été mis à jour.';
      }
      if (this.accountComponentType === 'newMember') {
        return 'L\'utilisateur a bien été ajouté.';
      }
      if (this.accountComponentType === 'deleteMember') {
        return 'Vous êtes sur le point de supprimer un utilisateur';
      }
      if (this.accountComponentType === 'createCompany') {
        return 'L\'entreprise a bien été ajouté à votre compte. Vous pouvez dès maintenant souscrire des contrats avec cette dernière.';
      }
      return 'La mise à jour de vos informations a bien été prise en compte.';
    },
    cta() {
      if (this.accountComponentType.includes('delete')) {
        return 'Supprimer';
      }
      if (['sepa', 'creditCard', 'newMember', 'createCompany'].includes(this.accountComponentType)) {
        return 'Terminer';
      }
      return 'Continuer';
    },
    action() {
      // function to be called when button is pressed
      if (!this.accountComponentAction) {
        return this[this.type.action];
      }
      return () => this.accountComponentAction() && this.close();
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  methods: {
    close() { this.ui_accountModal({ value: false, type: null }) },
    backAndClose() {
      this.close();
      this.$router.back();
    },
    async backCompaniesAndClose() {
      this.close();
      await this.$router.replace('/client').catch(() => {});
      this.$router.go(0);
    },
  },
};
</script>
